import { GetPurchaseReadyItemsState, GetPurchaseReadyItemsStatusState } from './getPurchaseReadyItems.types'

/**
 * What a status looks like before it has ever been fetched. Deliberately a
 * single shared instance: selectors fall back to it, and building a fresh object
 * on each call would hand `useSelector` a new reference every render and loop
 * the table.
 */
export const emptyPurchaseReadyItemsStatusState: GetPurchaseReadyItemsStatusState = {
  loading: false,
  error: null,
  success: null
}

const initialState: GetPurchaseReadyItemsState = {
  byStatus: {}
}

export default initialState
